import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/ruangbelajar";
var post = "/ruangbelajar";
export const actGetDataRumbel = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_RUMBEL_RUMBEL" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_RUMBEL_RUMBEL",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_RUMBEL_RUMBEL", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_RUMBEL_RUMBEL",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataRumbel = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_RUMBEL_RUMBEL" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 201) {
          successnotify("Class room has been created");
          return dispatch({
            type: "SUCCESS_RUMBEL_RUMBEL",
            message: "Success post data",
          });
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_RUMBEL_RUMBEL", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_RUMBEL_RUMBEL",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataRumbel = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_RUMBEL_RUMBEL" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Class room has been update");
          dispatch(__openModal({ modal: "MODAL_EDIT_RUMBEL", open: false }));
          return dispatch(actGetDataRumbel());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_RUMBEL_RUMBEL", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_RUMBEL_RUMBEL",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataRumbel = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({
      url: post + "/" + id,
      method: "GET",
    });
    dispatch({ type: "LOADING_RUMBEL_RUMBEL" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200 || Object.keys(data).length > 0) {
          return dispatch({
            type: "DETAIL_RUMBEL_RUMBEL",
            message: "Success get data",
            detail: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_RUMBEL_RUMBEL", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_RUMBEL_RUMBEL",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataRumbel = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_RUMBEL_RUMBEL" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Class room has been deleted");
          return dispatch({
            type: "SUCCESS_RUMBEL_RUMBEL",
            message: "Success get data",
          });
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_RUMBEL_RUMBEL", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_RUMBEL_RUMBEL",
          message: "Network error..",
        });
      });
  };
};
